import { usePersistedStore } from 'src/stores/persisted'
import { useCommonStore } from 'src/stores/common'
import { mapState } from 'pinia'

export default {
  data() {
    return {
      commonStore: useCommonStore(),
    }
  },
  computed: {
    ...mapState(useCommonStore, ['storeConfigurationLoaded']),
    ...mapState(usePersistedStore, [
      'isBetaAccessCodeValidated',
      'showEAIVPage',
    ]),
    isStoreActive() {
      // ToDo: SSR convert it to clientStoreConfigurationLoaded
      if (!this.storeConfigurationLoaded || !this.businessConfigurations)
        return false

      if (
        this.businessConfigurations.mode == 3 &&
        !this.isBetaAccessCodeValidated
      )
        return false
      if (
        this.businessConfigurations.mode == 2 &&
        !this.isBetaAccessCodeValidated
      )
        return false
      if (this.businessConfigurations.mode == 1) return false
      if (this.businessConfigurations.mode == 6) return false

      return true
    },
    canLoadDisclaimer() {
      if (window.location.pathname === '/templates-preview') return false
      if (!this.isStoreActive) return false

      return !!this.businessConfigurations?.showDisclaimer
    },
    isAgeVerificationRequired() {
      let isRequired = false

      if (
        this.businessConfigurations?.isStoreAgeRestricted &&
        this.showEAIVPage === true
      )
        isRequired = true
      return isRequired
    },
    canLoadAnnouncement() {
      if (!this.isStoreActive) return false

      if (
        this.isAgeVerificationRequired &&
        !this.$route.meta?.skipAgeVerification
      )
        return false

      return !!this.businessConfigurations?.showAnnouncement
    },
  },
  mounted() {
    if (this.canLoadDisclaimer) this.commonStore.getDisclaimer()
    else {
      let unwatchLoadDisclaimer = this.$watch('canLoadDisclaimer', (newVal) => {
        if (newVal) {
          this.commonStore.getDisclaimer()

          unwatchLoadDisclaimer()
        }
      })
    }

    if (this.canLoadAnnouncement) this.commonStore.getAnnouncement()
    else {
      let unwatchLoadAnnouncement = this.$watch(
        'canLoadAnnouncement',
        (newVal) => {
          if (newVal) {
            this.commonStore.getAnnouncement()
            unwatchLoadAnnouncement()
          }
        }
      )
    }
  },
}
